module.exports = __webpack_public_path__ + "static/img/img-products-3.86b49cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-products-3.png
// module id = 151
// module chunks = 2